import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

import { withTranslation } from "react-i18next";

import { connect } from "react-redux";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import { FynoInappCenter } from "@fyno/inapp-react";
import '../../assets/scss/purpleTheme/components/nav.scss';
import { useDispatch, useSelector } from "react-redux";
import {getSubscription as onGetSubscription,getAlertDeploymentCount}from "../../store/organization/actions";//18/09/2024

const Navbar = props => {
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [dashboard, setdashboard] = useState(false);
  const [app, setapp] = useState(false);
  const [app2, setapp2] = useState(false);
  const [alerts, setAlerts] = useState(false);
  const [alcomScoreDashboard, setAlcomScoreDashboard] = useState(false);

  useEffect(() => {
    let matchingMenuItem = null;
    let ul = document.getElementById("navigation");
    let items = ul.getElementsByTagName("li");
    removeActivation(items);
    for (let i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });
  useEffect(() => {
    dispatch(onGetSubscription());
    dispatch(getAlertDeploymentCount());
  }, [dispatch]);

  const { subscriptionDetail, alertsCount } = useSelector(state => ({
    subscriptionDetail: state.Organization.subscription,
    alertsCount: state.Organization.alertsCount?.alertsCount || state.Organization.alertsCount
  }));

  useEffect(() => {
    setTimeout(() => {
      const alertMessages = getAlertMessages(subscriptionDetail, alertsCount);
      if (alertMessages.length > 0) {
        setShowAlert(true);
      }
    }, 1000);
  }, [subscriptionDetail, alertsCount]);

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const themeConfig = {
    primary: "#556ee5",
    secondary: "#a6b0ce",
    //lightColor: "#222736",
    darkColor: "#222736",
    //lightBackground: "#FFFFFF",
    darkBackground: "#241a37",
    logo: 'https://prod-temperstack-public-assets.s3.ap-south-1.amazonaws.com/temperstack-logos/temperstack-logo.png',
  }

  const notificationSettings = {
    position: 'Top-right',
    duration: 10000,
    invertTheme: false
  }

  const removeActivation = items => {
    for (let i = 0; i < items.length; ++i) {
      let item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        }
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }
  const getAlertMessages = (subscriptionDetail, alertsCount) => {
    const counts = alertsCount?.alertsCount || alertsCount;
    if (Object.keys(subscriptionDetail).length === 0 || subscriptionDetail?.is_expired) {
      return ["Your subscription has expired! Please renew it."];
    }
    let alertParts = [];
    const scanLimitReached = counts?.resource_scan_count >= subscriptionDetail?.master_product_plan?.number_of_scans;
    const alertLimitReached = counts?.alert_deployment_count >= subscriptionDetail?.master_product_plan?.number_of_alert_deployments;
    const nearExpiry = subscriptionDetail?.is_near_expiry;
    if (scanLimitReached) {
      alertParts.push("Resource Scan");
    }
    if (alertLimitReached) {
      alertParts.push("Alert Deployment");
    }
    let limitMessage = "";
    if (alertParts.length > 1) {
      limitMessage = alertParts.join(" & ") + " limit has been reached";
    } else if (alertParts.length === 1) {
      limitMessage = alertParts[0] + " limit has been reached";
    }
    let finalMessage = "";
    if (limitMessage && nearExpiry) {
      finalMessage = `${limitMessage} and also subscription is about to expire in ${subscriptionDetail.days_left} days! Please renew it.`;
    } else if (limitMessage) {
      finalMessage = `${limitMessage}!`;
    } else if (nearExpiry) {
      finalMessage = `Your subscription is about to expire in ${subscriptionDetail.days_left} days! Please renew it.`;
    }
    return finalMessage ? [finalMessage] : [];
  };


  return (
    <React.Fragment>
      {showAlert && (
        <div
          style={{
            position:"fixed",
            left: 0,
            top:0,
            width: '100%',
            height: '4%',
            backgroundColor: 'rgba(255, 0, 0, 0.3)', // Semi-transparent red
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            backdropFilter: 'blur(10px)',
            textAlign:"center"
          }}
        >
          <div
            style={{
              position: 'relative',
              top: '0px',
              bottom:"20%",
              textAlign: 'center',
              alignItems:"center",
              height: '7%',
              padding: '20px',
              backgroundColor: 'transparent', // Dark background
              borderRadius: '5px',
              width: '100%',
            }}
          >
            <span style={{
              position: "absolute",
              top: "10px",
              left: "50%",
              transform: "translateX(-50%)",
              whiteSpace: "nowrap"
            }}>
              {getAlertMessages(subscriptionDetail, alertsCount)[0]}
            </span>
            <button
              onClick={handleCloseAlert}
              style={{
                position: 'absolute',
                top: '0px',
                right: '10px',
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: '20px',
                cursor: 'pointer',
              }}
            >
              x
            </button>
          </div>
        </div>
      )}
  
      <div className="topnav" style={{backgroundColor:"#4d43486a", backdropFilter:"blur(20px)", maxWidth:"100%"}}>
        <div className="container-fluid d-md-block" style={{maxWidth:"100%"}}>
          <nav
            className="navbar navbar-expand"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav ps-2">
                <li className="nav-item dropdown d-none d-md-block ms-2">
                  <Link to="/" className="logo logo-dark">
                    <span className="logo-sm">
                      <img src={themeConfig?.logo} alt="Temperstack-Logo" height="26"/>
                    </span>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <span className="logo-lg">
                        <img src={themeConfig?.logo} alt="Temperstack-Logo" height="24" style={{margin: '2px 5px 0 0'}}/>
                      </span>
                      {/*<span style={{ fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '19px', color: '#ffffff' }}>BlueJay</span>*/}
                    </div>
                  </Link>
                  <Link to="/" className="logo logo-light">
                    <span className="logo-sm">
                      <img src={themeConfig?.logo} alt="Temperstack-Logo" height="26"/>
                    </span>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <span className="logo-lg">
                        <img src={themeConfig?.logo} alt="Temperstack-Logo" height="24" style={{margin: '2px 5px 0 0'}}/>
                      </span>
                      {/*<span style={{ fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '19px', color: '#ffffff' }}>BlueJay</span>*/}
                    </div>
                  </Link>
                </li>
                <li className="nav-item dropdown padding-t-10" id="dropdownMenu1">
                  <Link className="nav-link-purple dropdown-toggle arrow-none" id="dropdownMenu1" data-toggle="dropdown" aria-expanded="false"
                        to={`/dashboard?tab=Dashboard`}>
                    <i className="bx bx-home-circle me-1"></i>
                    {props.t("Home")}
                  </Link>
                  <div className="dropdown-menu dropdown-bg" aria-labelledby="dropdownMenu1">
                    <Link
                      to={`/dashboard?tab=Dashboard`}
                      onClick={e => {
                        setdashboard(!dashboard);
                      }}
                      className="dropdown-item"
                    >
                      <i className="bx bx-home-circle me-2"></i>
                      {props.t("Dashboard")}
                    </Link>
                    <Link
                        to={`/dashboard?tab=SLO`}
                        onClick={e => {
                          setAlcomScoreDashboard(!alcomScoreDashboard);
                        }}
                        className="dropdown-item"
                    >
                      <i className="bx bx-stats me-2"></i>
                      {props.t("SLO Dashboard")}
                    </Link>
                    <Link
                        to={`/dashboard?tab=AlcomScoreDashboard`}
                      onClick={e => {
                        setAlcomScoreDashboard(!alcomScoreDashboard);
                      }}
                      className="dropdown-item"
                    >
                      <i className="mdi mdi-math-compass me-2"></i>
                      {props.t("Alcom Dashboard")}
                    </Link>
                    <Link
                        to={`/dashboard?tab=MissingAlerts`}
                        onClick={e => {
                          setAlcomScoreDashboard(!alcomScoreDashboard);
                        }}
                        className="dropdown-item"
                    >
                      <i className='bx bx-bell me-2'/>
                      {props.t("Missing Alerts")}
                    </Link>

                  </div>
                </li>
                <li className="nav-item dropdown padding-t-10" id="dropdownMenu1">
                  <i className="badge rounded-pill badge-soft-success position-absolute"
                     style={{top: '0', right: '0', transform: 'translate(40%,99%)', fontStyle: 'normal'}}>
                    New
                  </i>
                  <Link className="nav-link-purple dropdown-toggle arrow-none" id="dropdownMenu6"
                        to={`/alerts?tab=AlertsList`}
                        onClick={e => {
                          setAlerts(!alerts);
                        }}
                        data-toggle="dropdown"
                        aria-expanded="false">
                    <i className="bx bxs-bell-ring me-2"></i>
                    Alerts
                  </Link>
                  <div className="dropdown-menu dropdown-bg" aria-labelledby="dropdownMenu6">
                    <Link
                      to={`/alerts?tab=AlertsList`}
                      onClick={e => {
                        setAlerts(!alerts);
                      }}
                      className="dropdown-item"
                    >
                      <i className="bx bx-customize me-2"></i>
                      {props.t("Alerts List")}
                    </Link>
                    <Link
                      to={`/alerts?tab=AlertAnalytics`}
                      onClick={e => {
                        setAlcomScoreDashboard(!alcomScoreDashboard);
                      }}
                      className="dropdown-item"
                    >
                      <i className="mdi mdi-google-analytics me-2"></i>
                      {props.t("Alert Analytics")}
                    </Link>
                    <Link
                      to={`/alerts?tab=AlertsForOptimization`}
                      onClick={e => {
                        setAlcomScoreDashboard(!alcomScoreDashboard);
                      }}
                      className="dropdown-item position-relative"
                    >
                      <i className="bx bx-stats me-2"></i>
                      {props.t("Alerts Optimization")}
                    </Link>
                    <Link
                        to={`/alerts?tab=MTTA+MTTR`}
                        onClick={e => {
                          setAlerts(!alerts);
                        }}
                        className="dropdown-item"
                    >
                      <i className='mdi mdi-gauge me-2'/>
                    {props.t("MTTR MTTA")}
                    </Link>
                    <Link
                      to={`/daemon`}
                      onClick={e => {
                        setAlcomScoreDashboard(!alcomScoreDashboard);
                      }}
                      className="dropdown-item position-relative"
                    >
                      <i className="badge rounded-pill badge-soft-success position-absolute"
                         style={{
                           top: '-5%',
                           right: '10%',
                           transform: 'translateX(50%)',
                           fontStyle: 'normal'
                         }}>
                        New
                      </i>
                      <i className="dripicons-medical me-2"></i>
                      {props.t("Heal")}
                    </Link>
                  </div>
                </li>
                  <li className="nav-item dropdown padding-t-10" id="dropdownMenu1">
                    <Link className="nav-link-purple dropdown-toggle arrow-none" id="dropdownMenu1" data-toggle="dropdown" aria-expanded="false">
                      <i className="bx bx-customize me-2"></i>
                      Resources
                    </Link>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenu1">
                      <Link
                        to={`/cloud-resources`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <i className="fab fa-aws me-2"></i>
                        {props.t("AWS Resources")}
                      </Link>
                      <Link
                        to={`/gcp-resources`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <i className="bx bxl-google-cloud me-2"></i>
                        {props.t("GCP Resources")}
                      </Link>
                      <Link
                        to={`/azure-resources`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <i className="mdi mdi-microsoft-azure me-2"></i>
                        {props.t("Azure Resources")}
                      </Link>
                      <Link
                        to={`/oci-resources`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/oracle.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {props.t("OCI Resources")}
                      </Link>
                      <div className="dotted-break-line"></div>
                      <Link
                        to={`/new-relic-resources`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/newrelic.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {/*<i className="bx bx-customize me-2"></i>*/}
                        {props.t("NewRelic Resources")}
                      </Link>
                      <Link
                        to={`/datadog-resources`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/datadog.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {/*<i className="bx bx-customize me-2"></i>*/}
                        {props.t("Datadog Resources")}
                      </Link>
                      <Link
                        to={`/splunk-resources`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/splunk.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {/*<i className="bx bx-customize me-2"></i>*/}
                        {props.t("Splunk Resources")}
                      </Link>
                      <Link
                        to={`/appdynamics-resources`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/appdynamics.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)'}}/>
                        {/*<i className="bx bx-customize me-2"></i>*/}
                        {props.t("AppDynamics Resources")}
                      </Link>
                      <Link
                        to={`/dynatrace-resources`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/dynatrace.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)'}}/>
                        {/*<i className="bx bx-customize me-2"></i>*/}
                        {props.t("Dynatrace Resources")}
                      </Link>
                      <Link
                        to={`/ping-monitoring`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/temperstack.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)'}}/>
                        {/*<i className="bx bx-customize me-2"></i>*/}
                        {props.t("Temperstack Synthetics")}
                      </Link>
                      <Link
                          to={`/grafana-resources`}
                          onClick={e => {
                            setapp(!app);
                          }}
                          className="dropdown-item"
                      >
                        <img src="/icons/grafana.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)'}}/>
                        {/*<i className="bx bx-customize me-2"></i>*/}
                        {props.t("Grafana Resources")}
                      </Link>
                      <Link
                        to={`/signoz-resources`}
                        onClick={e => {
                          setapp(!app);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/signoz.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'invert(1)'}}/>
                        {/*<i className="bx bx-customize me-2"></i>*/}
                        {props.t("Signoz Resources")}
                      </Link>
                    </div>
                  </li>
                <li className="nav-item dropdown padding-t-10" id="dropdownMenu2">
                    <Link className="nav-link-purple dropdown-toggle arrow-none" id="dropdownMenu2" data-toggle="dropdown" aria-expanded="false">
                      <i className="bx bxs-analyse me-2"></i>
                      Templates
                    </Link>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                      <Link
                        to={`/thresholds`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <i className="fab fa-aws me-2"></i>
                        {props.t("AWS Templates")}
                      </Link>
                      <Link
                        to={`/gcp-thresholds`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <i className="bx bxl-google-cloud me-2"></i>
                        {props.t("GCP Templates")}
                      </Link>
                      <Link
                        to={`/azure-thresholds`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <i className="mdi mdi-microsoft-azure me-2"></i>
                        {props.t("Azure Templates")}
                      </Link>
                      <Link
                        to={`/oci-thresholds`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/oracle.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {props.t("OCI Templates")}
                      </Link>
                      <div className="dotted-break-line"></div>
                      <Link
                        to={`/new-relic-thresholds`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/newrelic.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {/*<i className="bx bx-copy-alt me-2"></i>*/}
                        {props.t("NewRelic Templates")}
                      </Link>
                      <Link
                        to={`/datadog-thresholds`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/datadog.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {/*<i className="bx bx-copy-alt me-2"></i>*/}
                        {props.t("Datadog Templates")}
                      </Link>
                      <Link
                        to={`/splunk-thresholds`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/splunk.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {/*<i className="bx bx-copy-alt me-2"></i>*/}
                        {props.t("Splunk Templates")}
                      </Link>
                      <Link
                        to={`/appdynamics-thresholds`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/appdynamics.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {/*<i className="bx bx-copy-alt me-2"></i>*/}
                        {props.t("AppDynamics Templates")}
                      </Link>
                      <Link
                        to={`/dynatrace-thresholds`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/dynatrace.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {/*<i className="bx bx-copy-alt me-2"></i>*/}
                        {props.t("Dynatrace Templates")}
                      </Link>
                      <Link
                          to={`/grafana-thresholds`}
                          onClick={e => {
                            setapp2(!app2);
                          }}
                          className="dropdown-item"
                      >
                        <img src="/icons/grafana.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {/*<i className="bx bx-copy-alt me-2"></i>*/}
                        {props.t("Grafana Templates")}
                      </Link>
                      <Link
                        to={`/signoz-thresholds`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/signoz.svg" alt="Customize Icon" className="me-2 svg-icon"/>
                        {/*<i className="bx bx-copy-alt me-2"></i>*/}
                        {props.t("Signoz Templates")}
                      </Link>
                    </div>
                  </li>
                <li className="nav-item dropdown padding-t-10" id="dropdownMenu2">
                    <Link className="nav-link-purple dropdown-toggle arrow-none" id="dropdownMenu2" data-toggle="dropdown" aria-expanded="false">
                      <i className="bx bx-alarm me-2"></i>
                      Notifications
                    </Link>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2" style={{marginLeft: '20px'}}>
                      <Link
                        to={`/temperstack-notifications`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <i className="dripicons-view-apps me-2"></i>
                        {props.t("Application Services")}
                      </Link>
                      <Link
                        to={`/oncall-policies`}
                        onClick={e => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <i className="bx bx-phone-call me-2"></i>
                        {props.t("On-Call Policies")}
                      </Link>
                    </div>
                  </li>
                  <li className="nav-item dropdown padding-t-10 d-inline-block position-relative" id="dropdownMenu2">
                    <Link
                      className="nav-link-purple dropdown-toggle arrow-none"
                      id="dropdownMenu2" data-toggle="dropdown"
                      aria-expanded="false">
                      <i className="bx bx-file me-2"></i>
                      Incidents
                    </Link>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2" style={{marginLeft: '20px'}}
                    >
                      <Link
                        to={`/status-page-management`}
                        onClick={(e) => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <i className="bx bxs-user-voice me-2"></i>
                        {props.t("Status Page")}
                      </Link>
                      <Link
                        to={`/RCA?tab=RCA`}
                        onClick={(e) => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <i className="mdi mdi-file-find-outline me-2"></i>
                        {props.t("Root Cause Analysis")}
                      </Link>
                    </div>
                  </li>
                  <li className="nav-item dropdown padding-t-10 d-inline-block position-relative" id="dropdownMenu2">
                    <Link
                      className="nav-link-purple dropdown-toggle arrow-none"
                      id="dropdownMenu2" data-toggle="dropdown"
                      aria-expanded="false">
                      <i className="bx bx-file me-2"></i>
                      Logging Systems
                    </Link>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2" style={{marginLeft: '20px'}}
                    >
                      <Link
                        to={`/sentry-projects`}
                        onClick={(e) => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/sentry.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {props.t("Sentry")}
                      </Link>
                      <Link
                        to={`/loki`}
                        onClick={(e) => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/loki.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {props.t("Loki")}
                      </Link>
                      <Link
                        to={`/coralogix`}
                        onClick={(e) => {
                          setapp2(!app2);
                        }}
                        className="dropdown-item"
                      >
                        <img src="/icons/coralogix.svg" alt="Customize Icon" className="me-2 svg-icon" style={{ filter: 'brightness(0) invert(1)' }}/>
                        {props.t("Coralogix")}
                      </Link>
                    </div>
                  </li>
              </ul>
            </Collapse>
            <div className="d-none d-md-block">
              <FynoInappCenter mode="dark"
                               user={localStorage.getItem("user_id")}
                               integration='IBE0E84F7053F'
                               workspace='FYAPB2412C435IN'
                               signature={localStorage.getItem("fyno_signature")}
                               themeConfig={themeConfig}
                notificationSettings={notificationSettings} />
            </div>
            <div className="me-4">
              <ProfileMenu />
            </div>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
);
